
<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20">
       <el-breadcrumb-item>云仓管理</el-breadcrumb-item>
        <el-breadcrumb-item>洋葱云仓</el-breadcrumb-item>
      </el-breadcrumb>
       <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="商品名称">
          <el-input size="small" clearable v-model="formInline.goodName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品ID">
          <el-input size="small" clearable v-model="formInline.goodId" placeholder="请输入商品ID"></el-input>
        </el-form-item>
        <el-form-item label="商品品牌">
          <el-input size="small" clearable v-model="formInline.brand" placeholder="请输入商品品牌"></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select
            size="small"
            clearable
            filterable
            v-model="formInline.classification"
            placeholder="请选择商品分类"
          >
            <el-option
              v-for="(item,i) in classificationOptions"
              :key="i"
              :label="item.classification"
              :value="item.classification"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select
            size="small"
            clearable
            filterable
            v-model="formInline.thirdGoodType"
            placeholder="请选择商品类型"
          >
            <el-option
              v-for="item in thirdGoodTypeOption"
              :key="item.key + '-smlxkey'"
              :label="item.key"
              :value="item.val"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-row class="mb20">
          <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="synOrigin" :disabled="isSynchronization">批量同步到本地商品</el-button>
        <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="showDrawer">更新商品字段</el-button>
        <el-button size="small" type="warning" plain icon="el-icon-refresh" @click="updateOrInsert">同步到中间表</el-button>
          <el-button size="small" type="success" plain icon="el-icon-refresh" @click="synGoodsUpdate">已同步数据更新</el-button>
        <el-button size="small" type="info" plain icon="el-icon-upload2" @click="handleExport">导出</el-button>
      </el-row>
      <!--列表-->
      <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="50">
        </el-table-column>
        <el-table-column align="center" prop="thirdGoodName" label="商品名称">
        </el-table-column>
        <el-table-column align="center" prop="thirdId" label="商品ID">
        </el-table-column>
        <el-table-column align="center" prop="brand" label="品牌">
        </el-table-column>
        <el-table-column align="center" prop="classification" label="分类">
        </el-table-column>
        <el-table-column align="center" label="商品类型">
         <!--  0-一般贸易,1-保税,2-海外直邮 -->
         <template slot-scope="scope">
           {{ typeNameList[scope.row.thirdGoodType*1] }}
         </template>
        </el-table-column>
        <el-table-column align="center" prop="priceSettlement" label="成本价">
        </el-table-column>
        <el-table-column align="center" prop="priceMarket" label="商品价">
        </el-table-column>
        <el-table-column align="center" prop="createDate" label="创建时间">
        </el-table-column>
        <el-table-column align="center" prop="updateDate" label="同步时间">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="50">
           <template slot-scope="scope">
             <el-button size="mini" type="success" plain @click="handleEdit(scope.row)">同步</el-button>
           </template>
         </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      <el-dialog
        title="选择字段同步商品"
        :visible.sync="commodityVisible"
        size="70%"
        :wrapperClosable="false"
        @close="hideDrawer">
        <div class="checkbox-area">
          <el-checkbox-group
            v-model="checkedData" @change="checkboxChange">
            <div class="checkbox-item" v-for="(item,index) in commodityData" :key="index">
              <el-checkbox   :label="item.name"  >{{item.label}}</el-checkbox>
            </div>

          </el-checkbox-group>
        </div>
        <div
          style="text-align: center;padding: 20px 0"
        >
          <el-button size="small" @click="hideDrawer"
          >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            :loading="loading"
            class="title"
            @click="saveData"
          >保存</el-button
          >
        </div>
      </el-dialog>
    </div>
   </template>
   <script>
   import {
       commoditySyncList,goodsUpdateOrInsert, synchronization, synchronizationUpdate,exportCloudStore,getThirdClassificationType,CommodityChoseUpdate
   } from '../../api/cloudStore'
   import {getClassiFicationTypeList} from "../../api/basisMG";
   import exportFile from '@/utils/exportFile'
   import {Loading} from "element-ui";
   import Pagination from '../../components/Pagination'
   export default {
    data() {
      return {
        loading: false, //是显示加载
        ids:'',
        isSynchronization:true, //同步按钮禁用
        typeNameList:['一般贸易','保税','海外直邮'],
        seletedata: {
          ids: '',
        },
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          thirdFlag:3,
        },
        userData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        classificationOptions:[],
        thirdGoodTypeOption:[
          {
            key:'一般贸易',
            val:0
          },
          {
            key:'保税',
            val:1
          },
          {
            key:'海外直邮',
            val:2
          }
        ],
        commodityVisible:!1,
        checkedData:[],
        commodityData:[
          {
            label:'商品名称',
            name:'name'
          },
          {
            label:'品牌',
            name:'band'
          },
          {
            label:'卖点',
            name:'adaptationDisease'
          },
          {
            label:'商品描述图',
            name:'description'
          },
          {
            label:'商品轮播图',
            name:'detailImage'
          },
          {
            label:'商品分类',
            name:'classification'
          },
          {
            label:'国家',
            name:'national'
          },
          {
            label:'售价',
            name:'amount'
          },
          {
            label:'vip价格',
            name:'vipAmount'
          },
          {
            label:'成本价',
            name:'interAmount'
          },
          {
            label:'库存',
            name:'stock'
          },
          {
            label:'重量',
            name:'weight'
          }
        ],
        submitData:{
          thirdFlag:3
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    watch: {},
    created() {
      this.getdata(this.formInline)
      this.getDictByTypeId()
    },
    methods: {
       // 同步数据 到本地商品
       synOrigin(){
           this.loading = true
           synchronization({id:this.ids}).then(res=>{
               if(res.rsp_code==200){
                   this.$message.success('同步成功！')
                   this.userData = res.body.records
                  // 分页赋值
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.limit
                  this.pageparm.total = res.body.total
                   this.loading = false
               }else{
                   this.loading = false
                   this.$message.error(res.rsp_msg)
               }
           })
       },
       // 同步数据 同步到中间表
       updateOrInsert(){
        this.loading = true
         goodsUpdateOrInsert().then(res=>{
          if(res.rsp_code==200){
                   this.$message.success('同步成功！')
                   this.loading = false
               }else{
                   this.loading = false
               }
         })
       },
       // 同步数据 同步数据更新
      synGoodsUpdate(){
        this.loading = true
        synchronizationUpdate().then(res=>{
          if(res.rsp_code==200){
                   this.$message.success('同步成功！')
                   this.loading = false
               }else{
                   this.loading = false
               }
         })
      },
      //获取分类字典
      getDictByTypeId() {
        getThirdClassificationType({thirdFlag:3}).then((res) => {
          this.classificationOptions = res.body; // 获取分类下拉列表
        });
      },
       selectChange(selection){
           if(selection.length>0){
               this.isSynchronization = false
           }else{
               this.isSynchronization = true
           }
           let ids;
           ids = selection.map(item => item.id)
           this.ids = ids.join()
           // console.log(this.ids);
       },
       handleEdit(row){
           const ids = row.id || this.ids
           this.loading = true
           synchronization({id:ids}).then(res=>{
               if(res.rsp_code==200){
                   this.$message.success('同步成功！')
                   this.getdata(this.formInline)
                   this.loading = false
               }else{
                   this.loading = false
               }
           })
       },
      // 获取数据方法
      getdata(parameter) {
        this.loading = true
        commoditySyncList(parameter).then(res => {
          this.loading = false
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.userData = res.body.records
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.body.total
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      //搜索事件
      search() {
       this.formInline.page=1
        this.getdata(this.formInline)
      },
      /** 导出按钮操作 */
      handleExport() {
        // this.download('system/goods/export', {
        //   ...this.queryParams
        // }, `goods_${new Date().getTime()}.xlsx`)
        let downloadLoadingInstance;
        downloadLoadingInstance = Loading.service({
          text: "正在下载数据，请稍候",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        })
        exportCloudStore({ids: this.ids,thirdFlag:3}).then(res => {
          exportFile.getExcel(res, `productList_${new Date().getTime()}`)
          downloadLoadingInstance.close()
        }).catch(() => {
          downloadLoadingInstance.close()
        })
      },
      //字段选择弹出
      showDrawer() {
        this.commodityVisible = !0
      },
      hideDrawer(){
        this.commodityVisible = !1
      },
      saveData() {

        for (let item of this.checkedData) {
          this.submitData[item] = 1
        }
        this.submitData.ids = this.ids
        console.log(this.submitData)
        this.loading = true
        CommodityChoseUpdate(this.submitData).then(res=>{
          if(res.rsp_code==200){
            this.$message.success({
              dangerouslyUseHTMLString: true,
              message: res.body
            })
            this.commodityVisible = !1
            this.getdata(this.formInline)
            this.loading = false
          }else{
            this.loading = false
            this.$message.error('同步失败！')
          }
        })
      },
      checkboxChange(n) {
        console.log(n)
      }
    }
   }
   </script>

   <style scoped>
   .user-search {
    margin-top: 20px;
   }
   .checkbox-area{
     padding: 40px;
   }
   .checkbox-item{
     margin-bottom: 10px;
     width: 33%;
     display: inline-block;
   }
   </style>




// WEBPACK FOOTER //
// src/views/cloudStore/yangcong.vue